/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Account Status
 */
export type GetUserResponseIntercomInfoAccountStatus = typeof GetUserResponseIntercomInfoAccountStatus[keyof typeof GetUserResponseIntercomInfoAccountStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserResponseIntercomInfoAccountStatus = {
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
  SUSPENDED: 'SUSPENDED',
} as const;
